/**
 * identity function. Returns the passed in value
 * @param element the value to return
 * @param T type of the element
 */
export function identity<T>(element: T): T {
    return element;
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/common/util/identity.ts